import { render } from "./GrigliaRicambiStorico.vue?vue&type=template&id=a3790a08"
import script from "./GrigliaRicambiStorico.vue?vue&type=script&lang=js"
export * from "./GrigliaRicambiStorico.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Ecommerce\\CONAD_MANUTENZIONI\\conad-manutenzioni\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__